// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'
import VueYouTubeEmbed from 'vue-youtube-embed'

// Store functionality
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'


Vue.use(Vuex)
Vue.use(VueYouTubeEmbed)

// Create a new store
const store = new Vuex.Store({
  mutations,
  state,
  actions,
  getters  
})

export default store